<button
  *ngIf="checkIn.isEditing"
  [disabled]="isCheckInEmpty"
  [attr.data-test-id]="'check-in-publish-or-save-btn'"
  (click)="checkInPublish.emit(type)"
  ui-button
  uiShape="round"
  uiType="primary"
  uiSize="large">
  {{ (checkIn.id ? "save" : "publish") | localize }}
</button>
<button *ngIf="!checkIn.isEditing" [attr.data-test-id]="'check-in-edit-btn'" (click)="checkInEdit.emit(type)" ui-button uiShape="round" uiType="default" uiSize="large">
  {{ "edit" | localize }}
</button>
<button
  class="sp-ml-16"
  *ngIf="checkIn.isEditing && checkIn.id"
  [attr.data-test-id]="'check-in-cancel-btn'"
  (click)="checkInCancel.emit(type)"
  ui-button
  uiShape="round"
  uiType="default"
  uiSize="large">
  {{ "cancel" | localize }}
</button>
